// extracted by mini-css-extract-plugin
export default {"contactPage":"Contact_contactPage__RnpZY"};